export const cleanTelNumber = (tel: string): string => {
  return tel
    .replaceAll('+', '')
    .replaceAll('-', '')
    .replaceAll('(', '')
    .replaceAll(')', '')
    .replaceAll(' ', '');
};
